import axios from "axios";
import { ROUTES } from "../Routes/routes";
import { toast } from "react-toastify";
import { navigateTo } from "./navigationService";

// Ensure baseURL doesn't have trailing slash
const baseURL = (process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');

export const apiAxios = axios.create({
  baseURL: baseURL,
  timeout: 0,
});

apiAxios.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");

  if (token) {
    config.headers.AuthorizationData = token;
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});


// Add response interceptor for debugging
apiAxios.interceptors.response.use(
  (response) => {

    // Log response structure for debugging
    return response;
  },
  (error) => {
    // Log detailed error information
    console.error(`❌ API Response Error: ${error.response?.status || 'No status'} ${error.config?.url}`);
    console.error("❌ Error details:", {
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      message: error.message,
      code: error.code
    });
    if (error.response?.status === 401) {
      sessionStorage.clear();
      navigateTo(ROUTES.LOGIN);
    }
    else if (error.response?.status === 403) {
      toast.error("You don't have permission to perform this action");
    } else if (error.code === 'ECONNABORTED') {
      toast.error("Request timeout - please try again");
    } else if (!error.response) {
      toast.error("Network error - please check your connection");
    }

    return Promise.reject(error);
  }
);